import React from 'react';

const Pricing = () => (
    <div className="container mx-auto text-center px-4 sm:px-6 lg:px-8 bg-gray-100 py-10 rounded-lg shadow-lg">
        <h2 className="text-3xl sm:text-4xl font-bold text-blue-600 mb-6">Pricing</h2>
        <p className="text-base sm:text-lg text-gray-700 leading-relaxed">
            Get access to all course materials, live sessions, and mentorship for just <span className="font-bold text-green-600">₹5999.00</span>!
        </p>
        <p className="mt-4 text-sm sm:text-base text-gray-600">
            <strong>Original Fee:</strong> ₹60,000.00 <br />
            <strong>Offer Price:</strong> ₹5999.00 (Valid till 9th April 2025)
        </p>
        <p className="mt-4 text-sm sm:text-base text-gray-600">
            Special Offer for Indian Students: Enroll now at just 10% of the original fee! Only the first 100 students will receive a 90% discount.
        </p>
    </div>
);

export default Pricing;
